// extracted by mini-css-extract-plugin
export default {"tooltip":"StaticLayout_tooltip__viviU"};